<template>
	<j-expendable-box class="bg5 b1 bc7 r2">
		<div
			slot="header"
			class="pl3 pr3 pt4 pb4 lh125 fs4 c1 fw7"
		>{{ $t("premium")}}</div>
		<div class="bt1 bc7 p4" slot="body">
			<offer-premium-info
				:caseId="$store.state.caseManagement.caseId"
				:proposalId="$store.state.caseManagement.proposalId"
				:offerId="$store.state.caseManagement.offerId"
				:productId="computedProduct.productId"
				:pricing="computedPricing"
				:hasLoadingsActions="true"
				:hasDiscountActions="true"
				:hasDiscountLogic="true"
				:hasPremiumActions="true"
				@premium:updated="updatePremium"
				@loadings:added="updatePremium"
				@loadings:deleted="updatePremium"
				@discount:added="updatePremium"
				@discount:deleted="updatePremium"
			/>
		</div>
	</j-expendable-box>
</template>

<script>
import JExpendableBox from "@/components/JExpendableBox"

import OfferPremiumInfo from "../PremiumInfo/OfferPremiumInfo"

export default {
	components: { JExpendableBox, OfferPremiumInfo },

	methods: {
		updatePremium() {
			this.$store.dispatch("caseManagement/fetchProposals", {
				caseId: this.$store.state.caseManagement.caseId
			})
		}
	},
	computed: {
		computedProduct() {
			const product = this.$store.getters["caseManagement/offer"]?.product
			return product ? product : {}
		},

		computedPricing() {
			const pricing = this.$store.getters["caseManagement/offer"]?.premium
			return pricing ? pricing : {}
		}
	}
}
</script>
